'use strict';

/**
 * @readonly
 * @enum {string}
 */
var CONFIG = {
  delimiters: {
    thousands: ',',
    decimal: '.'
  },
  abbreviations: {
    thousand: 'K',
    million: 'M',
    billion: 'B',
    trillion: 'T'
  },
  currency: {
    symbol: '$'
  }
};

/**
 * @readonly
 * @enum {string}
 */
var FORMATS = {
  NUMBER_NO_DECIMAL: '0,0',
  NUMBER: '0,0[.]00',
  NUMBER_LOGIT: '0,0[.]00000',
  NO_DECIMAL: '0',
  NUMBER_SHORT: '0,0[.]00a',
  CURRENCY: '$0,0[.]00',
  CURRENCY_NO_DECIMAL: '$0,0',
  CURRENCY_LONG: '$0,0.00',
  CURRENCY_SHORT: '$0,0[.]00a',
  PERCENTAGE: '0,0[.]00%',
  PERCENTAGE_SHORT: '0,0[.]00a%',
  NUMBER_DECIMAL: '0,0.00a'
};
var FormattingConstants = {
  CONFIG: CONFIG,
  FORMATS: FORMATS
};
module.exports = FormattingConstants;